import logoLight from "./RS-Tuinen_Kleur.png";
import heroImage from "./hero.png";
import project1 from "./project1.png";
import project2 from "./project2.png";
import project3 from "./project3.png";

export default function RSTuinenWebsiteConcept() {
  const services = [
    {
      title: "Tuinaanleg",
      text: "Van ontwerp tot realisatie. Wij verzorgen complete tuinen, afgestemd op uw wensen.",
    },
    {
      title: "Tuinonderhoud",
      text: "Structureel onderhoud zodat uw tuin er het hele jaar verzorgd bij ligt.",
    },
    {
      title: "Bestrating en Grind",
      text: "Het onderhouden en/of aanleggen van diverse sierbestrating en grind om uw tuin de gewenste uitstraling en vormen te geven.",
    },
    {
      title: "Houtbouw",
      text: "Van overkappingen tot maatwerk houtconstructies als praktische en stijlvolle aanvulling op uw tuin.",
    },
  ];

  const projects = [
    { title: "Complete tuinaanleg", image: project1 },
    { title: "Tuinonderhoud en seizoenswerk", image: project2 },
    { title: "Renovatie van bestaande tuinen", image: project3 },
  ];

  return (
    <div className="min-h-screen bg-[#f7f5ef] text-stone-800">
      <header className="sticky top-0 z-20 bg-[#f7f5ef]/60 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
          <a href="#" className="flex items-center shrink-0">
            <img
              src={logoLight}
              alt="RS Tuinen"
              className="h-12 w-auto opacity-90"
            />
          </a>

          <nav className="flex items-center gap-4 overflow-x-auto whitespace-nowrap text-[12px] font-medium text-stone-500 md:gap-8 md:text-[13px]">
            <a href="#diensten" className="hover:text-stone-900">
              Diensten
            </a>
            <a href="#projecten" className="hover:text-stone-900">
              Projecten
            </a>
            <a href="#over" className="hover:text-stone-900">
              Over
            </a>
          </nav>

          <a
            href="#contact"
            className="hidden md:inline-block rounded-full border border-[#d6c4af] px-5 py-2 text-[13px] font-medium text-[#7d6048] transition hover:border-[#b89f86] hover:bg-white"
          >
            Contact
          </a>
        </div>
      </header>

      <main>
        <section className="relative h-[70vh] overflow-hidden md:h-[80vh]">
          <img
            src={heroImage}
            alt="Tuin project"
            className="absolute inset-0 h-full w-full object-cover"
          />

          <div className="absolute inset-0 bg-black/40 md:bg-black/30" />

          <div className="relative z-10 flex h-full items-end">
            <div className="mx-auto w-full max-w-6xl px-6 pb-10 md:pb-16">
              <div className="max-w-xl text-white">
                <h1 className="text-3xl font-semibold leading-tight md:text-5xl">
                  Uw tuin van A tot Z geregeld
                </h1>

                <p className="mt-4 max-w-md text-base text-white/90 md:text-lg">
                  Van aanleg en renovatie tot onderhoud – RS Tuinen zorgt voor
                  een complete tuin waarin u kunt genieten.
                </p>

                <a
                  href="#projecten"
                  className="mt-6 inline-block rounded-full bg-white px-6 py-3 text-[14px] font-medium text-stone-900 transition hover:bg-[#f1ece2]"
                >
                  Bekijk projecten
                </a>
              </div>
            </div>
          </div>
        </section>

        <section
          id="diensten"
          className="mx-auto max-w-6xl px-6 py-24 md:py-32"
        >
          <div className="mb-10 max-w-2xl">
            <h2 className="text-3xl font-semibold">Diensten</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {services.map((service) => (
              <div
                key={service.title}
                className="rounded-2xl border border-[#e6e0d3] bg-white p-7 md:p-8"
              >
                <h3 className="text-xl font-semibold text-stone-900">
                  {service.title}
                </h3>
                <p className="mt-3 max-w-md text-[15px] leading-7 text-stone-600">
                  {service.text}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section id="projecten" className="bg-white py-24 md:py-32">
          <div className="mx-auto max-w-6xl px-6">
            <h2 className="mb-10 text-3xl font-semibold">Gerealiseerde projecten</h2>

            <div className="grid gap-8 md:grid-cols-3">
              {projects.map((project) => (
                <div key={project.title}>
                  <div className="group h-60 overflow-hidden rounded-xl">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                    />
                  </div>
                  <h3 className="mt-4 text-lg font-semibold">
                    {project.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="over" className="mx-auto max-w-6xl px-6 py-24 md:py-32">
          <h2 className="mb-6 text-3xl font-semibold">Over RS Tuinen</h2>
          <p className="max-w-2xl text-stone-600">
            RS Tuinen staat voor kwaliteit, duidelijke communicatie en een
            praktische aanpak. Van aanleg tot onderhoud, alles wordt compleet voor u verzorgd.
          </p>
        </section>

        <section
          id="contact"
          className="bg-[#5e6940] py-24 md:py-32 text-white"
        >
          <div className="mx-auto grid max-w-6xl gap-16 px-6 md:grid-cols-2 md:items-center">
            <div className="max-w-lg">
              <h2 className="mb-5 text-3xl font-semibold">Direct contact</h2>

              <p className="mb-8 text-[15px] leading-[1.8] text-white/80">
                Neem vrijblijvend contact op voor vragen, advies of een offerte op maat. RS Tuinen realiseert tuinaanleg, tuinonderhoud, bestrating en houtbouw in Badhoevedorp en Amsterdam en omstreken.
              </p>

              <div className="space-y-4 text-[15px] leading-[1.8] text-white/90">
                <div>
                  <div className="text-white/60">Telefoon</div>
                  <a
                    href="tel:+31626886294"
                    className="transition hover:text-white"
                  >
                    +31 6 26886294
                  </a>
                </div>

                <div>
                  <div className="text-white/60">Email</div>
                  <a
                    href="mailto:info@rs-tuinen.nl"
                    className="transition hover:text-white"
                  >
                    info@rs-tuinen.nl
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-[0_10px_40px_rgba(0,0,0,0.08)] md:p-8">
  <form
    action="https://api.web3forms.com/submit"
    method="POST"
    className="space-y-5"
  >
    <input
      type="hidden"
      name="access_key"
      value="228e93b7-a670-4e77-ac9f-3c2b162ff652"
    />

    <input
      type="hidden"
      name="subject"
      value="Nieuw bericht via RS Tuinen website"
    />

    <div>
      <label className="mb-2 block text-[13px] text-stone-500">
        Naam
      </label>

      <input
        type="text"
        name="naam"
        autoComplete="name"
        required
        className="w-full rounded-xl border border-[#e6e0d3] bg-[#f9f7f2] px-4 py-3 text-[15px] text-stone-800 outline-none transition focus:border-[#b89f86]"
      />
    </div>

    <div>
      <label className="mb-2 block text-[13px] text-stone-500">
        Email
      </label>

      <input
        type="email"
        name="email"
        autoComplete="email"
        required
        className="w-full rounded-xl border border-[#e6e0d3] bg-[#f9f7f2] px-4 py-3 text-[15px] text-stone-800 outline-none transition focus:border-[#b89f86]"
      />
    </div>

    <div>
      <label className="mb-2 block text-[13px] text-stone-500">
        Bericht
      </label>

      <textarea
        name="bericht"
        autoComplete="off"
        rows="5"
        required
        className="w-full rounded-xl border border-[#e6e0d3] bg-[#f9f7f2] px-4 py-3 text-[15px] text-stone-800 outline-none transition focus:border-[#b89f86]"
      />
    </div>

    <button
      type="submit"
      className="rounded-full bg-[#5e6940] px-6 py-3 text-[14px] font-medium text-white transition hover:bg-[#505a36]"
    >
      Verstuur bericht
    </button>
  </form>
</div>
          </div>
        </section>
      </main>

      <footer className="border-t border-[#e6e0d3] bg-[#f7f5ef] text-stone-800">
        <div className="mx-auto max-w-6xl px-6 py-14 md:py-16">
          <div className="grid items-start gap-12 md:grid-cols-3 md:gap-12">
            <div className="space-y-4">
              <img
                src={logoLight}
                alt="RS Tuinen"
                className="h-11 w-auto opacity-95"
              />

              <div className="flex flex-col gap-1 text-[14px] leading-[1.5] text-stone-600">
                <a href="#diensten" className="transition hover:text-stone-900">
                  Diensten
                </a>
                <a
                  href="#projecten"
                  className="transition hover:text-stone-900"
                >
                  Projecten
                </a>
                <a href="#over" className="transition hover:text-stone-900">
                  Over
                </a>
                <a href="#contact" className="transition hover:text-stone-900">
                  Contact
                </a>
              </div>

              <p className="max-w-[300px] text-[14px] leading-[1.6] text-stone-600">
                RS Tuinen onderhoudt en realiseert tuinen in Badhoevedorp en Amsterdam en omstreken. Kwaliteit, duidelijke communicatie en een praktische aanpak staan centraal.
              </p>
            </div>

            <div className="space-y-5 md:justify-self-center">
              <div className="text-[12px] uppercase tracking-[0.16em] text-stone-500">
                Contact
              </div>

              <div className="space-y-3 text-[14px] leading-[1.6] text-stone-600">
                <div className="space-y-0">
                  <div>Telefoon</div>
                  <a
                    href="tel:+31626886294"
                    className="block transition hover:text-stone-900"
                  >
                    +31 6 26886294
                  </a>
                </div>

                <div className="space-y-0">
                  <div>Email</div>
                  <a
                    href="mailto:info@rs-tuinen.nl"
                    className="block transition hover:text-stone-900"
                  >
                    info@rs-tuinen.nl
                  </a>
                </div>

                <div className="space-y-0">
                  <div>Adres</div>
                  <div>Raasdorperweg 189 A</div>
                  <div>1175 KV Lijnden</div>
                </div>
              </div>
            </div>

            <div className="space-y-5 md:text-right">
              <div className="text-[12px] uppercase tracking-[0.16em] text-stone-500">
                Juridisch
              </div>

              <div className="flex flex-col gap-1 text-[14px] leading-[1.5] text-stone-600 md:items-end">
                <div>KvK: 71625038</div>
                <a
                  href="/algemene-voorwaarden.html"
                  className="transition hover:opacity-70"
                >
                  Algemene voorwaarden
                </a>
                <a
                  href="/cookiebeleid.html"
                  className="transition hover:opacity-70"
                >
                  Cookiebeleid
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 border-t border-[#e6e0d3] pt-6">
            <div className="flex flex-col gap-2 text-[13px] text-stone-500 md:flex-row md:items-center md:justify-between">
              <div>© {new Date().getFullYear()} RS-Tuinen</div>
              <div>Groot Amsterdam · Noord-Holland</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
